<template>
  <div id="spa-root">
    <router-view />
    <UpgradeModal
      :show="upgradeModal.show"
      :cv-count="upgradeModal.cvCount"
      :cv-limit="upgradeModal.cvLimit"
      :feature="upgradeModal.feature"
      :authenticated="upgradeModal.authenticated"
      @close="upgradeModal.show = false"
    />
  </div>
</template>

<script setup>
import { reactive, onMounted, onUnmounted } from 'vue'
import UpgradeModal from './components/UpgradeModal.vue'
import { apiEvents } from './services/ApiService.js'

const upgradeModal = reactive({ show: false, cvCount: 0, cvLimit: 5, feature: 'cv_limit', authenticated: true })

function onUpgradeRequired(event) {
  const detail = event.detail || {}
  upgradeModal.cvCount = detail.cv_count ?? 0
  upgradeModal.cvLimit = detail.cv_limit ?? 5
  upgradeModal.feature = detail.feature || 'cv_limit'
  upgradeModal.authenticated = detail.authenticated ?? true
  upgradeModal.show = true
}

onMounted(() => apiEvents.addEventListener('upgrade-required', onUpgradeRequired))
onUnmounted(() => apiEvents.removeEventListener('upgrade-required', onUpgradeRequired))
</script>

<style>
#spa-root {
  min-height: 100vh;
}
</style>
